export default __webpack_public_path__ + "static/media/Metropolis-SemiBold.6cecad78.ttf";